import React from 'react';
import logoIcon from '../assets/logo-icon-exact.png';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';

function Privacy() {
  const navigate = useNavigate();

  return (
    <div className="settings-page">
      <header>
        <div className="logo" onClick={() => navigate('/')}>
          <div className="logo-icon"><img src={logoIcon} alt="" /></div>
          <div className="logo-text">TradeReady<span>Pro</span></div>
        </div>
        <div className="header-right">
          <Link to="/quiz" className="dark-toggle">Home</Link>
          <Link to="/settings" className="dark-toggle" title="Settings">⚙️</Link>
        </div>
      </header>

      <div className="settings-wrap" style={{ maxWidth: 720 }}>
        <button className="settings-back" onClick={() => navigate(-1)}>← Back</button>
        <h1 className="settings-title">Privacy Policy</h1>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginBottom: '2rem' }}>Last updated: May 2026</p>

        <div className="static-content">

          <h2>Who we are</h2>
          <p>TradeReady Pro is an Ontario-based exam preparation platform for trade certification candidates. You can reach us at <a href="mailto:support@tradereadypro.ca">support@tradereadypro.ca</a>.</p>

          <h2>What we collect</h2>
          <ul>
            <li>Your <strong>email address</strong> when you create an account</li>
            <li>Your <strong>quiz scores and study history</strong> when you complete quizzes</li>
            <li>Your <strong>subscription status</strong> (active, cancelled, plan type)</li>
            <li>Your <strong>dark mode and grading mode preferences</strong>, stored locally in your browser</li>
          </ul>
          <p>We do not collect your name, phone number, or payment card details. We never see your credit card information — that is handled entirely by Stripe.</p>

          <h2>How we store your data</h2>
          <p>Your account and quiz data is stored securely using <strong>Supabase</strong>, a cloud database provider. All data is encrypted in transit and at rest. Payment processing is handled by <strong>Stripe</strong> — we only store a Stripe customer ID to link your account to your subscription. We never store card numbers, expiry dates, or CVVs.</p>

          <h2>How we use your data</h2>
          <ul>
            <li>To run your account and let you log in</li>
            <li>To display your quiz scores and progress on your dashboard</li>
            <li>To manage your subscription through Stripe</li>
            <li>To send transactional emails such as password resets</li>
          </ul>
          <p>We do not sell your data, share it with advertisers, or use it for any purpose beyond running the app.</p>

          <h2>Cookies and local storage</h2>
          <p>We use browser local storage to remember your preferences (dark mode, grading mode) and to cache your subscription status between sessions. We do not use tracking cookies or third-party analytics tools.</p>

          <h2>Your rights</h2>
          <p>You can <strong>delete your account</strong> at any time from <Link to="/settings">Settings → Delete Account</Link>. This permanently removes your account, all quiz history, and your subscription record from our systems. The deletion is immediate and cannot be undone.</p>
          <p>If you want a copy of your data or have a privacy concern, email us at <a href="mailto:support@tradereadypro.ca">support@tradereadypro.ca</a> and we will respond within 5 business days.</p>

          <h2>Third-party services</h2>
          <p>We use the following services to run TradeReady Pro:</p>
          <ul>
            <li><strong>Supabase</strong> — database and authentication (<a href="https://supabase.com/privacy" target="_blank" rel="noreferrer">supabase.com/privacy</a>)</li>
            <li><strong>Stripe</strong> — payment processing (<a href="https://stripe.com/privacy" target="_blank" rel="noreferrer">stripe.com/privacy</a>)</li>
            <li><strong>Cloudflare Pages</strong> — website hosting (<a href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noreferrer">cloudflare.com/privacypolicy</a>)</li>
          </ul>
          <p>None of these services sell your personal data.</p>

          <h2>Contact</h2>
          <p>For any privacy questions: <a href="mailto:support@tradereadypro.ca">support@tradereadypro.ca</a></p>

        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Privacy;
